import { createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "../../../redux/slice";
import * as api from "../api";

export const doGetAllLabels = createAsyncThunk("groups/doGetAllLabels", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doGetAllLabels(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doCreateLabel = createAsyncThunk("groups/doCreateLabel", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doCreateLabel(params);
    if (!error) thunkAPI.dispatch(setMessage("You action has been completed successfully"));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateLabel = createAsyncThunk("groups/doUpdateLabel", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doUpdateLabel(params);
    if (!error) thunkAPI.dispatch(setMessage("You action has been completed successfully"));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doDeleteLabel = createAsyncThunk("groups/doDeleteLabel", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doDeleteLabel(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});
